import { BaseEndpoint } from "../base.endpoint"
import { MailchimpCartAttributes } from "../../types/attributes"
import { Params } from "../../types/request"

export class Mailchimp extends BaseEndpoint {
  public async createCart(
    body: MailchimpCartAttributes,
    params: Params
  ): Promise<MailchimpCartAttributes> {
    const { data } = await this.http.post(
      this.routes.mailchimpCreateCartPath(),
      { ...body },
      {
        params,
      }
    )
    return data
  }

  public async deleteCart(
    id: string,
    params: Params
  ): Promise<MailchimpCartAttributes> {
    const { data } = await this.http.delete(
      this.routes.mailchimpDeleteCartPath(),
      {
        params: {
          id,
          ...params,
        },
      }
    )
    return data
  }
}
